<!-- BudoPopup 统一 vant 新老版本的 形式 供 FloatBall 使用 -->

<template>
  <van-popup v-model="popupShow" closeable position="left" :style="{ width: '80vw', height: '100vh' }">
    <slot></slot>
  </van-popup>
</template>

<script>
window._api_popup_menu_list_ = "/v5/popup-menu-list"

export default {
  props: ['value'],

  data() {
    return {
      popupShow: false
    }
  },

  watch: {
    value() {
      this.popupShow = this.value
    },

    popupShow() {
      this.$emit("input", this.popupShow)
    }
  },

  mounted() {
    this.popupShow = this.value
  }
}
</script>